<template>
    <div>
        <header class="panel__header">
            <aside>
                <h2 class="panel__title">Manage channels</h2>
            </aside>
        </header>

        <table class="table">
            <thead>
                <tr>
                    <th>Channel</th>
                    <th>Members</th>
                    <th>Guests</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr data-locator="channel-row" v-for="channel in channels" :key="channel.id" :id="`channel-${channel.id}`" :class="{ 'is-disabled': channel.archived_at !== null }">
                    <td data-locator="channel-name"><strong>{{ channel.name }}</strong></td>
                    <td data-locator="channel-member-count">{{ channel.member_count }}</td>
                    <td data-locator="channel-guest-count">{{ channel.guest_count }}</td>
                    <td>
                        <slot :channel="channel"></slot>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'ChannelList',

    computed: {
        ...mapState(['channels'])
    }
}
</script>
